export const INTEGRATION_CONFIG_MYBANX_COMPANY_ID = 'companyId';

export const myBanxDefaultConfigurations = {
  [INTEGRATION_CONFIG_MYBANX_COMPANY_ID]: '',
};
